export const UPDATE_FILE_REFERENCE_REQUEST = 'UPDATE_FILE_REFERENCE_REQUEST';

export const updateFileReferenceRequest = ( id: string, updateData: {} ) => ({
    type: UPDATE_FILE_REFERENCE_REQUEST,
    payload: { id, updateData }
});
